{
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }

    const item_list_id = sessionStorage.getItem("item_list_id") || "";
    const item_list_name = sessionStorage.getItem("item_list_name") || "";
    const page_location = window.location.href
    const page_referrer = document.referrer
    const page_title = document.title
    const currency = "CAD"

    function findParent(element, className) {
        while (element.parentElement && !element.parentElement.classList.contains(className)) {
            element = element.parentElement;
        }
        return element.parentElement;
    }

    function ga4_dealy_report(data) {
        const base_data = ga4_user_data()
        sessionStorage.setItem("ga4_dealy_report", JSON.stringify({
            ...data, "event": "delayed_ga4Event", "common_delayed_data": {
                ...base_data,
                page_location,
                page_referrer,
                page_title,
                item_list_id,
                item_list_name
            }
        }))
    }




    // 用户基础数据
    function ga4_user_data() {
        function detectDevice() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // 检测平板
            if (/iPad|Tablet|PlayBook|Silk/i.test(userAgent) ||
                (/\bAndroid\b/i.test(userAgent) && !/\bMobile\b/i.test(userAgent))) {
                return "Tablet";
            }

            // 检测手机
            if (/Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                return "Mobile";
            }

            // 默认是 PC
            return "PC";
        }

        const operating_platform = detectDevice();
        // Example for accessing event data
        const login_status = window.UGrequest?.CUSTOMER_ID ? "Logged" : "Logout"
        const user_id = window.UGrequest?.CUSTOMER_ID || "" // 第一次接受 cookie 的时候，是空的，刷新页面后才会有值
        const country_code = "CA"
        const content_group = document.title
        const pathname = window?.location?.pathname
        // // 用户基础数据
        // Shopify?.analytics?.publish('ga4Event_base', {
        //     "log_name": "用户基础数据:",
        //     content_group,
        //     country_code,
        //     login_status,
        //     operating_platform,
        //     user_id,
        //     pathname,
        //     page_location,
        //     page_referrer,
        //     page_title,
        // })
        return {
            operating_platform,
            login_status,
            user_id,
            pathname,
            country_code,
            content_group,
            page_location
        }
    }
    // if (Shopify) {
    //     // 如果 Shopify 存在，则立即执行 ga4_user_data
    //     ga4_user_data(); // 用户基础数据提前执行获取，避免数据误差
    // } else {
    //     setTimeout(ga4_user_data, 500)
    // }


    // 页面浏览深度
    function ga4_scroll_data() {
        let maxScrollReported = 0;

        window?.addEventListener('scroll', function () {
            // 计算滚动百分比
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercent = (scrollTop / docHeight) * 100;

            // 判断当前滚动百分比是否达到下一个 25% 的阈值
            if (scrollPercent >= maxScrollReported + 25) {
                // 更新已上报的最大滚动百分比
                maxScrollReported = Math.floor(scrollPercent / 25) * 25;

                // 将滚动百分比的值传递到 dataLayer
                Shopify.analytics.publish('ga4Event', {
                    "log_name": "页面浏览深度:",
                    "event_name": "scroll",
                    "event_parameters": {
                        "percent_scrolled": maxScrollReported
                    }
                });
            }
        });
    }
    ga4_scroll_data();


    // 导航各按钮
    function ga4_menu_data() {
        const menuItems = document.querySelectorAll('.t4s-menu-item > a') || [];

        menuItems.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const parentElement = findParent(event.target, 't4s-type__drop');
                if (parentElement) {
                    const navigationName1 = parentElement.querySelector('a')?.innerText;
                    const navigationName2 = event.target?.innerText;
                    ga4_dealy_report({
                        "event": "ga4Event",
                        "log_name": "导航按钮--二级:",
                        "event_name": "top_navigation",
                        "event_parameters": {
                            "navigation_name": navigationName1 + "_" + navigationName2
                        }
                    })
                } else {
                    const navigationName1 = event.target?.innerText;
                    ga4_dealy_report({
                        "log_name": "导航按钮--一级:",
                        "event": "ga4Event",
                        "event_name": "top_navigation",
                        "event_parameters": {
                            "navigation_name": navigationName1
                        }
                    });
                }
            });
        });
    }
    ga4_menu_data();

    // 超级菜单按钮
    function ga4_super_menu_data() {
        const superMenuItems = document.querySelectorAll('.ug-tab-product-list > a') || [];
        const collectionItems = document.querySelectorAll('.ug-tab-collection > a') || [];
        console.log("超级菜单按钮:", superMenuItems);
        console.log("超级菜单按钮222:", collectionItems);
        superMenuItems.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item.querySelector('.ug-tab-product-title')?.innerText;
                ga4_dealy_report({
                    "log_name": "超级菜单按钮:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Top Navigation",
                        button_name
                    }
                });
            });
        });
        collectionItems.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item?.innerText;
                ga4_dealy_report({
                    "log_name": "超级菜单按钮:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Top Navigation",
                        button_name
                    }
                });
            });
        });
    }
    // ga4_super_menu_data();

    // 测试上下国家弹窗
    function ga4_country_dialog_data() {
        const open_country_btn_top = document.querySelector('#ug-top-current-country');
        const open_country_btn_bottom = document.querySelector('#ug-current-country');
        open_country_btn_top?.addEventListener('click', function (event) {
            const button_name = open_country_btn_top.querySelector('.ug-current-country-text')?.innerText;

            Shopify.analytics.publish('ga4Event', {
                "log_name": "顶部国家按钮:",
                "event_name": "country_switch",
                "event_parameters": {
                    "module": "Top module",
                    button_name
                }
            });
        });
        open_country_btn_bottom?.addEventListener('click', function (event) {
            const button_name = open_country_btn_bottom.querySelector('.ug-current-country-text')?.innerText;

            Shopify.analytics.publish('ga4Event', {
                "log_name": "底部国家按钮:",
                "event_name": "country_switch",
                "event_parameters": {
                    "module": "Buttom module",
                    button_name
                }
            });
        });
    }
    setTimeout(ga4_country_dialog_data, 1000)


    // 测试国家按钮点击
    function ga4_country_select_data() {
        const countryItems = document.querySelectorAll('.ug-select-country-dialog__main .ug-select-country-dialog__body__list__item a') || [];
        countryItems.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item?.innerText;

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "国家按钮:",
                    "event_name": "country_select",
                    "event_parameters": {
                        "module": "Buttom module",
                        button_name
                    }
                });
            });
        });
    }
    setTimeout(ga4_country_select_data, 1000)

    // 顶部栏按钮点击
    function ga4_top_bar_data() {
        const logo = document.querySelector('.t4s-section-header .t4s-header__logo');
        logo?.addEventListener('click', function (event) {
            const button_name = "Logo";

            ga4_dealy_report({
                "log_name": "顶部栏按钮:",
                "event_name": "top_function",
                "event_parameters": {
                    "module": "Top Fuction",
                    button_name
                }
            });
        })
        const search_btn = document.querySelector('.t4s-section-header .t4s-site-nav__search');
        search_btn?.addEventListener('click', function (event) {
            const button_name = "Search";

            Shopify.analytics.publish('ga4Event', {
                "log_name": "顶部栏按钮:",
                "event_name": "top_function",
                "event_parameters": {
                    "module": "Top Fuction",
                    button_name
                }
            });
        })
        const cart_btn = document.querySelector('.t4s-section-header .t4s-site-nav__cart');
        cart_btn?.addEventListener('click', function (event) {
            const button_name = "Cart";

            Shopify.analytics.publish('ga4Event', {
                "log_name": "顶部栏按钮:",
                "event_name": "top_function",
                "event_parameters": {
                    "module": "Top Fuction",
                    button_name
                }
            });
        })
        const account_btn = document.querySelector('.t4s-section-header .t4s-site-nav__account');
        account_btn?.addEventListener('click', function (event) {
            const button_name = "Account";

            Shopify.analytics.publish('ga4Event', {
                "log_name": "顶部栏按钮:",
                "event_name": "top_function",
                "event_parameters": {
                    "module": "Top Fuction",
                    button_name
                }
            });
        })
    }


    // 底部导航
    function ga4_bottom_nav_data() {
        const bottom_nav_items = document.querySelectorAll('.t4s-footer-linklist .t4s-footer-link') || [];
        bottom_nav_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const navigation_name = item?.innerText;
                ga4_dealy_report({
                    "log_name": "底部导航:",
                    "event_name": "bottom_navigation",
                    "event_parameters": {
                        navigation_name
                    }
                });
            })
        })
    }


    // 社媒按钮
    function ga4_social_btn_data() {
        const social_btn_items = document.querySelectorAll('.socials-icon-wrap') || [];
        const ugreen_social_btn_items = document.querySelectorAll('.ugreen_social .swiper-slide.item > a') || [];
        social_btn_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = ["tiktok", "instagram", "facebook", "twitter", "youtube"].find(name => item.href.includes(name));

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "社媒按钮:",
                    "event_name": "bottom_function",
                    "event_parameters": {
                        button_name,
                        position: "Bottom nav"
                    }
                });
            })
        })
        ugreen_social_btn_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = ["tiktok", "instagram", "facebook", "twitter", "youtube"].find(name => item.href.includes(name));

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "社媒按钮:",
                    "event_name": "bottom_function",
                    "event_parameters": {
                        button_name,
                        position: "Home Ugreen Social"
                    }
                });
            })
        })
    }


    /************************ 购物车模块 **************************/
    function ga4_cart_data() {
        // 选择要监听的父容器
        const miniCartContainer = document.querySelector('#t4s-mini_cart');

        // 使用事件委托监听父容器的点击事件
        miniCartContainer?.addEventListener('click', function (event) {
            // 检查点击的元素的祖先是否是加号按钮
            if (event.target.closest('.t4s-quantity-selector.is--plus')) {
                const target = event.target.closest('[data-ga4-product]');
                const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: 1 })];

                add_to_cart_data_reporting({
                    "button_name": "Mini Cart Plus Button",
                    "position": "Mini Cart",
                    "item_list_id": item_list_id,
                    "item_list_name": item_list_name,
                }, product_list_data);
            }

            // 检查点击的元素的祖先是否是减号按钮
            if (event.target.closest('.t4s-quantity-selector.is--minus')) {
                const target = event.target.closest('[data-ga4-product]');
                const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: 1 })];
                const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                Shopify.analytics.publish('ga4Event', {
                    "log_name": "产品减购按钮点击:",
                    "event_name": "remove_from_cart",
                    "event_parameters": {
                        "items": product_list_data,
                        "button_name": "Mini Cart Minus Button",
                        "position": "Mini Cart",
                        "value": value,
                        "currency": currency,
                        "item_list_id": item_list_id,
                        "item_list_name": item_list_name,
                    }
                });
            }

            // 检查点击的元素的祖先是否是删除按钮
            if (event.target.closest('.t4s-mini_cart__remove')) {
                const target = event.target.closest('[data-ga4-product]');
                const quantity = target.querySelector('.t4s-quantity-input')?.value || 1;
                const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: Number(quantity) })];
                const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "删除按钮:",
                    "event_name": "remove_from_cart",
                    "event_parameters": {
                        "items": product_list_data,
                        "button_name": "Mini Cart Minus Button",
                        "position": "Mini Cart",
                        "item_list_id": item_list_id,
                        "item_list_name": item_list_name,
                        "value": value,
                        "currency": currency,
                    }
                });
            }

            // 检查点击的元素的祖先是否是 checkout 按钮
            if (event.target.closest('.t4s-btn__checkout')) {
                const button_name = "Checkout Button";

                ga4_dealy_report({
                    "log_name": "跳转 checkout 按钮:",
                    "event_name": "click_checkout_button",
                    "event_parameters": {
                        "module": "Checkout Module",
                        button_name,
                        position: "Mini Cart"
                    }
                });
            }

            // 检查点击的元素的祖先是否是 view cart 按钮
            if (event.target.closest('.t4s-btn__cart')) {
                const button_name = "View Cart Button";

                ga4_dealy_report({
                    "log_name": "跳转 Main Cart 按钮:",
                    "event_name": "click_view_cart_button",
                    "event_parameters": {
                        "module": "Checkout Module",
                        button_name,
                        position: "Mini Cart"
                    }
                });
            }

            // 检查点击的元素的祖先是否是运费预估按钮
            if (event.target.closest('.t4s-get__rates')) {
                const button_name = "Estimated";
                const module = window.UGrequest.page_type === "cart" ? "Cart Page" : "Cart Sidebar";

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "获取运费按钮:",
                    "event_name": "freight_estimate",
                    "event_parameters": {
                        "module": module,
                        button_name,
                        position: "Mini Cart"
                    }
                });
            }

            // 检查点击的元素的祖先是否是输入框
            if (event.target.closest('.t4s-quantity-input')) {
                const target = event.target.closest('[data-ga4-product]');
                const input = target.querySelector('.t4s-quantity-input');

                // 检查是否已经添加了监听器
                if (!input.dataset.listenerAdded) {
                    const old_quantity = input.value || 1;
                    input.addEventListener('change', (event) => {
                        const new_quantity = event.target.value || 1;

                        if (new_quantity !== old_quantity) {
                            const quantity_change = new_quantity - old_quantity;
                            const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: Math.abs(quantity_change) })];
                            const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                            if (quantity_change > 0) {
                                Shopify.analytics.publish('ga4Event', {
                                    "log_name": "input 修改 加购:",
                                    "event_name": "add_to_cart",
                                    "event_parameters": {
                                        "items": product_list_data,
                                        "button_name": "Mini Cart Input",
                                        "position": "Mini Cart",
                                        "item_list_id": item_list_id,
                                        "item_list_name": item_list_name,
                                        "value": value,
                                        "currency": currency,
                                    }
                                });
                            } else {
                                Shopify.analytics.publish('ga4Event', {
                                    "log_name": "input 修改 减购:",
                                    "event_name": "remove_from_cart",
                                    "event_parameters": {
                                        "items": product_list_data,
                                        "button_name": "Mini Cart Input",
                                        "position": "Mini Cart",
                                        "item_list_id": item_list_id,
                                        "item_list_name": item_list_name,
                                        "value": value,
                                        "currency": currency,
                                    }
                                });
                            }
                        }
                    });

                    // 标记监听器已添加
                    input.dataset.listenerAdded = true;
                }
            }
        });
    }



    /************************ 主页模块 **************************/

    // Shop by Category模块
    function ga4_index_shop_by_category_data() {
        const shop_by_category_items = document.querySelectorAll('.ug-index-category .ug-index-category-item-wrap') || [];
        shop_by_category_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item.querySelector('.ug-index-category-item-name')?.innerText;

                ga4_dealy_report({
                    "log_name": "Shop by Category模块:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Shop by Category",
                        "button_name": button_name
                    }
                });
            })
        })
    }

    // Ugreen Fits Your Life 模块
    function ga4_index_ugreen_fits_your_life_data() {
        const ugreen_fits_your_life_items = document.querySelectorAll('.ug-new-fit-life-section .new-fit-life-item') || [];
        ugreen_fits_your_life_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item.querySelector('.item-title')?.innerText;

                ga4_dealy_report({
                    "log_name": "Ugreen Fits Your Life模块:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Home Ugreen Fits Your Life",
                        button_name
                    }
                });
            })
        })
    }

    // Ugreen Benefits 模块
    function ga4_index_ugreen_benefits_data() {
        const ugreen_benefits_items = document.querySelectorAll('.ug-benefit .ug-benefit-box > a') || [];
        ugreen_benefits_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item.querySelector('.title')?.innerText;

                ga4_dealy_report({
                    "log_name": "Ugreen Benefits模块:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Home Ugreen Benefits",
                        button_name
                    }
                });
            })
        })
    }

    // Ugreen index blogs
    function ga4_index_ugreen_blogs_data() {
        const ugreen_blogs_items = document.querySelectorAll('.ug-index-blog .ug-index-blog__item-link') || [];
        ugreen_blogs_items.forEach(function (item) {
            item?.addEventListener('click', function (event) {
                const button_name = item.querySelector('.ug-index-blog__item-title')?.innerText;

                Shopify.analytics.publish('ga4Event', {
                    "log_name": "Ugreen Blogs模块:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": "Home Ugreen Blogs",
                        button_name
                    }
                });
            })
        })
    }


    /************************ 专辑页 **************************/
    if (window.UGrequest.page_type === "collection") {
        // 顶部 icons bar
        function ga4_collection_top_icons_bar_data() {
            const top_icons_bar_items = document.querySelectorAll('.related_icons_bar_wrap .related_icon') || [];
            top_icons_bar_items.forEach(function (item) {
                item?.addEventListener('click', function (event) {
                    const category = item.querySelector('h5')?.innerText;

                    ga4_dealy_report({
                        "log_name": "顶部 icons bar:",
                        "event_name": "select_item_category",
                        "event_parameters": {
                            category
                        }
                    });
                })
            })
        }

        // FAQ
        function ga4_collection_faq_data() {
            const faq_items = document.querySelectorAll('.t4s-accor-title') || [];
            const module = document.querySelector('.ug-faq-section-title')?.innerText;
            faq_items.forEach(function (item) {
                item?.addEventListener('click', function (event) {
                    const button_name = item.querySelector('.t4s-accor-text')?.innerText;

                    Shopify.analytics.publish('ga4Event', {
                        "log_name": "FAQ:",
                        "event_name": "click_button",
                        "event_parameters": {
                            module,
                            button_name
                        }
                    });
                })
            })
        }

    }

    /************************ 产品页 **************************/

    // 产品信息区域按钮点击
    function ga4_product_info_area_data() {
        const module = "Purchase"
        const product_a_plus_items = [{
            button_name: "breadcrumb",
            dom: ".t4s-dib",
            event_name: "click_button",
            log_name: "面包屑"
        },
        {
            button_name: "Product Carousel Previous",
            dom: "#Purchase .flickityt4s-prev-next-button.previous",
            event_name: "click_button",
            log_name: "产品轮播上一页按钮"
        },
        {
            button_name: "Product Carousel Next",
            dom: "#Purchase .flickityt4s-prev-next-button.next",
            event_name: "click_button",
            log_name: "产品轮播下一页按钮"
        },
        {
            button_name: "Product Image Carousel",
            dom: "#Purchase .t4s-carousel__nav-item",
            event_name: "click_button",
            log_name: "产品缩略图轮播按钮"
        },
        {
            button_name: "Product Carousel Zoom",
            dom: "#Purchase .t4s-pr__pswp-btn",
            event_name: "click_button",
            log_name: "产品轮播放大按钮"
        },
        {
            dom: "#Purchase .shipping-icon",
            event_name: "click_button",
            log_name: "运费图标"
        },
        {
            button_name: "Discount Copy",
            dom: ".t4s-product__info-wrapper .ug-product-discount-btn",
            event_name: "click_button",
            log_name: "折扣复制按钮"
        },
        {
            button_name: "Show Short Description",
            dom: ".t4s-product__info-wrapper .ug-product-short-desc",
            event_name: "click_button",
            log_name: "展开短描述 Body 点击"
        },
        {
            button_name: "Show Short Description",
            dom: ".t4s-product__info-wrapper .foldBtn-wrap",
            event_name: "click_button",
            log_name: "显示短描述按钮 Learn More 按钮"
        },
        {
            button_name: "Klarna Placement",
            dom: ".t4s-product__info-wrapper .klarna-placement",
            event_name: "click_button",
            log_name: "Klarna 按钮"
        },
        {
            button_name: "Jump to Review",
            dom: ".t4s-product__info-wrapper .t4s-product__review",
            event_name: "click_button",
            log_name: "跳到 Review 按钮"
        }
        ];
        dom_listen({ dataList: product_a_plus_items, module, position: "Product Info Area" })
    }

    // tabs 切换
    function ga4_product_tabs_data() {
        const module = "Product Tabs"
        const dataList = [{
            dom: "#ugreen-product-tabs .green-custom-tab",
            event_name: "click_button",
            log_name: "产品 tabs 切换"
        }]
        dom_listen({ dataList, module })
    }

    // 产品A+区域点击
    function ga4_product_a_plus_data() {
        const module = "Overview"
        const product_a_plus_items = [{
            button_name: "video play btn",
            dom: "#Overview .ug-m3u8-video-itemdiv",
            event_name: "click_button",
            log_name: "视频播放按钮"
        },
        {
            button_name: "aplus-goto-btn",
            dom: "#Overview .aplus-goto-btn",
            event_name: "click_button",
            log_name: "A+按钮"
        },
        {
            button_name: "a-carousel-goto-prevpage",
            dom: "#Overview .a-carousel-goto-prevpage",
            event_name: "click_button",
            log_name: "上一页按钮"
        },
        {
            button_name: "a-carousel-goto-nextpage",
            dom: "#Overview .a-carousel-goto-nextpage",
            event_name: "click_button",
            log_name: "下一页按钮"
        },
        {
            button_name: "ug-custom-desc-carousel-btn",
            dom: "#Overview .ug-custom-desc-carousel-btn",
            event_name: "click_button",
            log_name: "自定义描述轮播按钮"
        }
        ];
        dom_listen({ dataList: product_a_plus_items, module })
    }

    // Reviews 区域按钮点击(插件拿不到)
    function ga4_product_reviews_data() {

    }
    // FAQ
    function ga4_product_faq_data() {
        const module = "FAQ"
        const dataList = [{
            button_name: "faq title",
            dom: "#FAQ .simpQuestionHolder",
            event_name: "click_button",
            log_name: "FAQ 标题"
        }]
        dom_listen({ dataList, module })
    }

    function ga4_product_add_to_cart_data() {
        const product_info = window.UGrequest.product_info;
        const add_to_cart_btn = document.querySelector('[data-atc-form]');
        add_to_cart_btn?.addEventListener('click', function (event) {
            const quantity = document.querySelector('.t4s-product-form__buttons [data-quantity-value]')?.value || 1;
            const product_list_data = [
                Object.assign({}, product_info, product_info?.variants ? product_info.variants.find(item => item.selected) : {}, { quantity: Number(quantity) })
            ]
            add_to_cart_data_reporting({
                "button_name": "Add To Cart",
                "position": "product_detail",
                "item_list_id": item_list_id,
                "item_list_name": item_list_name,
            }, product_list_data);
        })
        setTimeout(() => {
            const sticky_atc = document.querySelector('.t4s-sticky-atc__atc');
            sticky_atc?.addEventListener('click', function (event) {
                const quantity = document.querySelector('.t4s-sticky-atc__btns [data-quantity-value]')?.value || 1;
                const product_list_data = [
                    Object.assign({}, product_info, product_info?.variants ? product_info.variants.find(item => item.selected) : {}, { quantity: Number(quantity) })
                ]
                add_to_cart_data_reporting({
                    "button_name": "Add To Cart",
                    "position": "sticky_atc",
                    "item_list_id": item_list_id,
                    "item_list_name": item_list_name,
                }, product_list_data);
            })
        }, 2000)
    }


    /************************ 常规页 **************************/
    if (window.UGrequest.page_type === "page") {
        // tabs 点击
        function ga4_page_tabs_data() {
            const module = "Page Tabs"
            const dataList = [{
                dom: ".tabs_list-main .tabs_list-item",
                event_name: "click_button",
                log_name: "tabs 标题"
            }]
            dom_listen({ dataList, module })
        }
        ga4_page_tabs_data()
    }

    /************************ 登录页 **************************/
    if (window.UGrequest.page_type === "customers/account" && (document.referrer.includes("login") || document.referrer.includes("challenge"))) {
        // 登录按钮
        function ga4_login_data() {
            Shopify.analytics.publish('ga4Event', {
                "event_name": "login"
            });
        }
        ga4_login_data()
    }
    /************************ 注册页 **************************/
    if (window.UGrequest.page_type === "index" && document.referrer.includes("register") && window.UGrequest.CUSTOMER_ID) {
        // 注册按钮
        function ga4_register_data() {
            Shopify.analytics.publish('ga4Event', {
                "event_name": "sign_up",
            });
        }
        ga4_register_data()
    }

    /************************ 产品详情页 **************************/
    // 页面加载上报
    function ga4_product_detail_data() {
        const product_info = window.UGrequest.product_info;
        Shopify.analytics.publish('ga4Event', {
            "log_name": "产品详情页加载",
            "event_name": "view_item",
            "event_parameters": {
                "position": "product_detail",
                "currency": currency,
                "value": product_info.price,
                "item_list_id": item_list_id,
                "item_list_name": item_list_name,
                "items": [
                    Object.assign({}, product_info, product_info?.variants ? product_info.variants.find(item => item.selected) : {})
                ]
            }
        });
    }
    // 子款式切换上报
    function ga4_product_variant_data(index) {
        const product_info = window.UGrequest.product_info;
        window.UGrequest.product_info.variants[index].selected = true;
        Shopify.analytics.publish('ga4Event', {
            "log_name": "产品详情页子款式切换:",
            "event_name": "view_item",
            "event_parameters": {
                "position": "product_variant_select",
                "currency": currency,
                "value": product_info.price,
                "item_list_id": item_list_id,
                "item_list_name": item_list_name,
                "items": [
                    {
                        "item_list_id": item_list_id,
                        "item_list_name": item_list_name,
                        ...product_info,
                        ...product_info.variants[index]
                    }
                ]
            }
        });
    }
    if (window.UGrequest.page_type === "product") {
        document.addEventListener('DOMContentLoaded', function () {
            ga4_product_detail_data()
            const variantBtns = document.querySelectorAll('[data-swatch-item].t4s-swatch__item');
            variantBtns.forEach((item, index) => {
                item.addEventListener('click', function () {
                    ga4_product_variant_data(index)
                })
            })

        })
    }

    /************************ 通用函数 **************************/
    function dom_listen({ dataList, module, position }) {
        dataList.forEach(function (item) {
            const dom = document.querySelectorAll(item.dom) || [];
            dom?.forEach(function (domItem) {
                domItem?.addEventListener('click', function (event) {
                    // 不传 button_name 就拿按钮内部文案
                    const button_name = item.button_name ? item.button_name : domItem.innerText || domItem.classList;
                    click_event_data_reporting({
                        event_name: item.event_name,
                        log_name: item.log_name,
                        position,
                        module,
                        button_name
                    })
                })
            })
        })
    }

    function click_event_data_reporting({ event_name = "click_button", module, button_name, log_name }) {

        const event_parameters = module ? { module, button_name } : { button_name };
        Shopify.analytics.publish('ga4Event', {
            "log_name": log_name,
            "event_name": event_name,
            event_parameters
        });
    }
    function add_to_cart_data_reporting(event_parameters, product_list_data) {
        const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
        Shopify.analytics.publish('ga4Event', {
            "log_name": "产品加购按钮点击:",
            "event_name": "add_to_cart",
            event_parameters: {
                "currency": currency,
                "value": value,
                "items": product_list_data,
                ...event_parameters,
            }
        });
    }

    class UgGa4Track extends HTMLElement {
        constructor() {
            super();
            // 创建并附加一个开放的 Shadow DOM
            this.attachShadow({ mode: 'open' });
            this.module = this.getAttribute('module');
            this.button_name = this.getAttribute('button_name');
            this.log_name = this.getAttribute('log_name');
            this.item_list_id = sessionStorage.getItem("item_list_id");
            this.item_list_name = sessionStorage.getItem("item_list_name");
            this.page_number = this.getAttribute('page_number') || "";
            this.type = this.getAttribute('type');
            this.position = this.getAttribute('position');
            // 购物车总价
            this.total_price = this.getAttribute('total_price');
            // banner 曝光
            this.creative_slot = this.getAttribute('creative_slot');
            this.creative_name = this.getAttribute('creative_name');
            this.creative_id = this.getAttribute('creative_id');
            this.index = this.getAttribute('index');
            this.shadowRoot.innerHTML = `
        <slot></slot>
      `;
            //   this.slot = this.shadowRoot.querySelector('slot')?.assignedElements?.()?.[0] || null;
            //   console.log('this.slot-------------', this.slot);
        }

        connectedCallback() {
            if (this.type === "product-list-exposure") {
                this.initObserver();
            }
            // 产品点击
            if (this.type === "product-click") {
                this.productClickListener();
            }
            // mini cart 曝光
            if (this.type === "mini_cart") {
                this.miniCartExposure();
            }
            // cart 曝光
            if (this.type === "main_cart") {
                this.cartExposure();
            }
            // banner 曝光
            if (this.type === "banner-exposure") {
                this.bannerExposure();
            }
            // swiper banner 曝光
            if (this.type === "swiper-banner-exposure") {
                this.swiperBannerExposure();
            }
            // button click
            if (this.type === "button-click") {
                this.buttonClick();
            }
            // mega menu 曝光
            if (this.type === "mega-menu-exposure") {
                this.megaMenuExposure();
            }
        }
        // 初始化 IntersectionObserver
        initObserver() {
            const slot = this.shadowRoot.querySelector('slot');
            if (slot.assignedElements().length > 0) {
                // 获取分配的第一个元素（即插槽内的内容）
                const target = slot.assignedElements()[0];
                // 使用 IntersectionObserver 观察这个目标元素
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // 当元素进入视口时触发曝光上报
                            this.reportExposure();
                            // 产品点击
                            this.productClickListener();
                            // 如果只需要一次曝光上报，可以在这里停止观察
                            observer.disconnect();
                        }
                    });
                }, {
                    threshold: 0.5  // 当50%的内容出现在视口时，认为其曝光
                });

                // 观察分配到 slot 的第一个元素
                observer.observe(target);
            }
        }

        reportExposure() {
            const product_list = this.querySelectorAll("[data-ga4-product]");
            const product_list_data = [];
            product_list.forEach((item) => {
                product_list_data.push(JSON.parse(item.getAttribute('data-ga4-product')));
            })
            Shopify.analytics.publish('ga4Event', {
                "event_name": "view_item_list",
                "log_name": this.log_name || "产品列表曝光",
                "event_parameters": {
                    "currency": currency,
                    "item_list_id": this.item_list_id,
                    "item_list_name": this.item_list_name,
                    "page_number": this.page_number,
                    "items": product_list_data,
                    "position": this.position,
                }
            });
        }

        // 监听 mega menu 是否展开
        listenMegaMenuVisible() {
            const product_dropdown = document.querySelector('#t4s-nav-ul .t4s-type__mega:first-child');
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.attributeName === 'class' && mutation.target.className.includes('is-action__hover')) {
                        console.log('mega menu 已经展开!');
                        this.reportExposure();
                        // 产品点击
                        this.productClickListener();
                        observer.disconnect();
                    }
                });
            });
            observer.observe(product_dropdown, {
                attributes: true,  // 监听属性的变化
                attributeFilter: ['class'],  // 只监听 class 属性
            });
        }
        // 产品点击事件，包含加购
        productClickListener() {
            const product_list = this.querySelectorAll("[data-ga4-product]");
            product_list.forEach((item) => {
                item.addEventListener('click', (event) => {
                    const product_list_data = [JSON.parse(item.getAttribute('data-ga4-product'))];
                    const isAddToCartBtn = event.currentTarget.hasAttribute('data-action-atc') || event.target.hasAttribute('data-action-atc') || event.target.closest('[data-action-atc]');
                    if (isAddToCartBtn) {
                        add_to_cart_data_reporting({
                            "button_name": this.button_name || "Add To Cart",
                            "position": this.position || "product_add_to_cart",
                            "item_list_id": this.item_list_id,
                            "item_list_name": this.item_list_name,
                        }, product_list_data);
                        return;
                    }
                    if (item.getAttribute('target') === '_blank') {
                        Shopify.analytics.publish('ga4Event', {
                            "log_name": "产品信息区域按钮:",
                            "event_name": "select_item",
                            "event_parameters": {
                                "items": product_list_data,
                                "position": this.position || "product_info_area",
                                "button_name": this.button_name || event.target.innerText || "product_click",
                                "currency": currency,
                                "item_list_id": this.item_list_id,
                                "item_list_name": this.item_list_name,
                            }
                        });
                    } else {
                        ga4_dealy_report({
                            "log_name": "产品信息区域按钮:",
                            "event_name": "select_item",
                            "event_parameters": {
                                "items": product_list_data,
                                "position": this.position || "product_info_area",
                                "button_name": this.button_name || event.target.innerText || "product_click",
                                "currency": currency,
                                "item_list_id": this.item_list_id,
                                "item_list_name": this.item_list_name,
                            }
                        });
                    }
                })
            })
        }
        // mini cart 曝光
        miniCartExposure() {
            const mini_cart = document.querySelector('#t4s-mini_cart');
            let is_mini_cart_visible = false;
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.attributeName === 'aria-hidden' && mutation.target.getAttribute('aria-hidden') === 'false') {
                        console.log('mini cart 已经展开!');
                        // mini cart 购物车数据上报
                        ga4_cart_data()
                        const product_list = mini_cart.querySelectorAll("[data-ga4-product]");
                        const product_list_data = [];
                        product_list.forEach((item) => {
                            product_list_data.push(JSON.parse(item.getAttribute('data-ga4-product')));
                        })

                        setTimeout(() => {
                            const value = Number(this.getAttribute('total_price'))

                            Shopify.analytics.publish('ga4Event', {
                                "log_name": "mini cart 曝光",
                                "event_name": "view_cart",
                                "event_parameters": {
                                    "currency": currency,
                                    "value": value,
                                    "item_list_id": this.item_list_id,
                                    "item_list_name": this.item_list_name,
                                    "items": product_list_data,
                                    "position": "mini_cart",
                                }
                            });
                        }, 1000)
                        observer.disconnect();
                    }
                });
            });
            observer.observe(mini_cart, {
                attributes: true,  // 监听属性的变化
                attributeFilter: ['aria-hidden'],  // 只监听 class 属性
            });
        }
        // main cart 曝光
        cartExposure() {
            const cart_items = document.querySelectorAll('[data-ga4-product]');
            const product_list_data = [];
            cart_items.forEach((item) => {
                product_list_data.push(JSON.parse(item.getAttribute('data-ga4-product')));
            })
            setTimeout(() => {
                const value = Number(this.getAttribute('total_price'))
                Shopify.analytics.publish('ga4Event', {
                    "log_name": "main cart 曝光",
                    "event_name": "view_cart",
                    "event_parameters": {
                        "currency": currency,
                        "value": value,
                        "item_list_id": this.item_list_id,
                        "item_list_name": this.item_list_name,
                        "position": "Main Cart",
                        "items": product_list_data
                    }
                });
            }, 1000)

            const main_cart = document.querySelector('.t4s-main-cart');
            
            main_cart.addEventListener('click', (event) => {
                // 加购按钮
                if (event.target.closest('.t4s-page_cart__item  .t4s-quantity-selector.is--plus')) {
                    const target = event.target.closest('[data-ga4-product]')
                    const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: 1 })];
                    const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                    add_to_cart_data_reporting({
                        "button_name": "Main Cart Plus Button",
                        "position": "Main Cart",
                        "item_list_id": this.item_list_id,
                        "item_list_name": this.item_list_name,
                        "value": value,
                    }, product_list_data);
                }
                // 减购按钮
                if (event.target.closest('.t4s-page_cart__item  .t4s-quantity-selector.is--minus')) {
                    const target = event.target.closest('[data-ga4-product]')
                    const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: 1 })]
                    const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                    Shopify.analytics.publish('ga4Event', {
                        "log_name": "产品减购按钮点击:",
                        "event_name": "remove_from_cart",
                        "event_parameters": {
                            "items": product_list_data,
                            "button_name": "Main Cart Minus Button",
                            "position": "Main Cart",
                            "item_list_id": this.item_list_id,
                            "item_list_name": this.item_list_name,
                            "value": value,
                            "currency": currency,
                        }
                    });
                }
                // 删除按钮
                if (event.target.closest('.t4s-page_cart__remove')) {
                    const target = event.target.closest('[data-ga4-product]')
                    const quantity = target.querySelector('.t4s-quantity-input')?.value || 1;
                    const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: Number(quantity) })]
                    const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                    Shopify.analytics.publish('ga4Event', {
                        "log_name": "产品减购按钮点击:",
                        "event_name": "remove_from_cart",
                        "event_parameters": {
                            "items": product_list_data,
                            "button_name": "Main Cart Delete Button",
                            "position": "Main Cart",
                            "item_list_id": this.item_list_id,
                            "item_list_name": this.item_list_name,
                            "value": value,
                            "currency": currency,
                        }
                    });
                }
                // 跳转 checkout 按钮
                if (event.target.closest('.t4s-btn__checkout')) {
                    ga4_dealy_report({
                        "log_name": "跳转 checkout 按钮:",
                        "event_name": "click_checkout_button",
                        "event_parameters": {
                            "module": "Checkout Module",
                            "button_name": "Checkout Button",
                            "position": "Main Cart",
                        }
                    });
                }

                           // 检查点击的元素的祖先是否是输入框
            if (event.target.closest('.t4s-quantity-input')) {
                const target = event.target.closest('[data-ga4-product]');
                const input = target.querySelector('.t4s-quantity-input');

                // 检查是否已经添加了监听器
                if (!input.dataset.listenerAdded) {
                    const old_quantity = input.value || 1;
                    input.addEventListener('change', (event) => {
                        const new_quantity = event.target.value || 1;

                        if (new_quantity !== old_quantity) {
                            const quantity_change = new_quantity - old_quantity;
                            const product_list_data = [Object.assign({}, JSON.parse(target.getAttribute('data-ga4-product')), { quantity: Math.abs(quantity_change) })];
                            const value = product_list_data.reduce((total, item) => total + item.price * item.quantity, 0);
                            if (quantity_change > 0) {
                                Shopify.analytics.publish('ga4Event', {
                                    "log_name": "input 修改 加购:",
                                    "event_name": "add_to_cart",
                                    "event_parameters": {
                                        "items": product_list_data,
                                        "button_name": "Main Cart Input",
                                        "position": "Main Cart",
                                        "item_list_id": item_list_id,
                                        "item_list_name": item_list_name,
                                        "value": value,
                                        "currency": currency,
                                    }
                                });
                            } else {
                                Shopify.analytics.publish('ga4Event', {
                                    "log_name": "input 修改 减购:",
                                    "event_name": "remove_from_cart",
                                    "event_parameters": {
                                        "items": product_list_data,
                                        "button_name": "Main Cart Input",
                                        "position": "Main Cart",
                                        "item_list_id": item_list_id,
                                        "item_list_name": item_list_name,
                                        "value": value,
                                        "currency": currency,
                                    }
                                });
                            }
                        }
                    });

                    // 标记监听器已添加
                    input.dataset.listenerAdded = true;
                }
            }
            })
        }
        // banner 曝光
        bannerExposure() {
            const slot = this.shadowRoot.querySelector('slot');
            if (slot.assignedElements().length > 0) {
                // 获取分配的第一个元素（即插槽内的内容）
                const target = slot.assignedElements()[0];
                // 使用 IntersectionObserver 观察这个目标元素
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // 当元素进入视口时触发曝光上报
                            const banner_data = JSON.parse(this.getAttribute('data-ga4-banner'));

                            Shopify.analytics.publish('ga4Event', {
                                "log_name": this.log_name || "banner 曝光",
                                "event_name": "view_promotion",
                                "event_parameters": {
                                    "promotion_id": banner_data?.creative_id,
                                    "promotion_name": banner_data?.creative_name,
                                    "creative_name": banner_data?.creative_name,
                                    "creative_slot": banner_data?.creative_slot,
                                    "button_name": banner_data?.button_name,
                                    "index": banner_data?.index,
                                    "position": this.position,
                                    "item_list_id": this.item_list_id,
                                    "item_list_name": this.item_list_name,
                                }
                            });
                            // banner 点击监听
                            target.addEventListener('click', () => {

                                Shopify.analytics.publish('ga4Event', {
                                    "log_name": "banner 点击",
                                    "event_name": "select_promotion",
                                    "event_parameters": {
                                        "promotion_id": banner_data?.creative_id,
                                        "promotion_name": banner_data?.creative_name,
                                        "creative_name": banner_data?.creative_name,
                                        "creative_slot": banner_data?.creative_slot,
                                        "button_name": banner_data?.button_name,
                                        "index": banner_data?.index,
                                        "position": this.position,
                                        "item_list_id": this.item_list_id,
                                        "item_list_name": this.item_list_name,
                                    }
                                });
                            })
                            observer.disconnect();
                        }
                    });
                }, {
                    threshold: 0.5  // 当50%的内容出现在视口时，认为其曝光
                });
                observer.observe(target);  // 观察分配到 slot 的第一个元素
            }
        }
        // swiper banner 曝光
        swiperBannerExposure() {
            const slot = this.shadowRoot.querySelector('slot');

            // 用于存储已经曝光的 slide
            const exposedSlides = new Set();

            if (slot.assignedElements().length > 0) {
                const target = slot.assignedElements()[0];
                const swiper_slides = target.querySelectorAll('[data-ga4-banner]');

                const observer = new MutationObserver((mutationsList) => {
                    mutationsList.forEach((mutation) => {
                        if (mutation.attributeName === 'class' && (mutation.target.classList.contains('swiper-slide-active') || mutation.target.classList.contains('is-selected'))) {
                            const swiper_banner_data = JSON.parse(mutation.target.getAttribute('data-ga4-banner'));

                            // 确保 swiper_banner_data 存在
                            if (swiper_banner_data) {
                                // 使用 Set 记录已经曝光的 slide，避免重复上报
                                if (!exposedSlides.has(swiper_banner_data.creative_id)) {
                                    exposedSlides.add(swiper_banner_data.creative_id);  // 将 slide ID 加入 Set


                                    Shopify.analytics.publish('ga4Event', {
                                        "log_name": this.log_name || "swiper banner 曝光",
                                        "event_name": "view_promotion",
                                        "event_parameters": {
                                            "promotion_id": swiper_banner_data.creative_id,
                                            "promotion_name": swiper_banner_data.creative_name,
                                            "creative_name": swiper_banner_data.creative_name,
                                            "creative_slot": swiper_banner_data.creative_slot,
                                            "index": swiper_banner_data.index,
                                            "position": this.position,
                                            "item_list_id": this.item_list_id,
                                            "item_list_name": this.item_list_name,
                                        }
                                    });
                                }
                            }
                        }
                    });
                });

                // 为每个 slide 设置观察
                swiper_slides.forEach((swiper_slide) => {
                    observer.observe(swiper_slide, {
                        attributes: true,  // 监听属性的变化
                        attributeFilter: ['class'],  // 只监听 class 属性
                    });
                    swiper_slide.addEventListener('click', () => {
                        const swiper_banner_data = JSON.parse(swiper_slide.getAttribute('data-ga4-banner'));

                        Shopify.analytics.publish('ga4Event', {
                            "log_name": "swiper banner 点击:",
                            "event_name": "select_promotion",
                            "event_parameters": {
                                "promotion_id": swiper_banner_data.creative_id,
                                "promotion_name": swiper_banner_data.creative_name,
                                "creative_name": swiper_banner_data.creative_name,
                                "creative_slot": swiper_banner_data.creative_slot,
                                "index": swiper_banner_data.index,
                                "position": this.position,
                                "item_list_id": this.item_list_id,
                                "item_list_name": this.item_list_name,
                            }
                        });
                    })
                });
            }
        }
        // button Click
        buttonClick() {
            const button = this.shadowRoot.querySelector('slot');
            button.addEventListener('click', () => {
                Shopify.analytics.publish('ga4Event', {
                    "log_name": this.log_name || "button 点击:",
                    "event_name": "click_button",
                    "event_parameters": {
                        "module": this.module,
                        "button_name": this.button_name,
                        "item_list_id": this.item_list_id,
                        "item_list_name": this.item_list_name,
                    }
                });
            })
        }
        // mega menu 曝光
        megaMenuExposure() {
            this.listenMegaMenuVisible();
        }

    }
    document.addEventListener('DOMContentLoaded', () => {
        // 注册自定义元素
        customElements.define('ug-ga4-track', UgGa4Track);
        ga4_top_bar_data()
        ga4_bottom_nav_data()
        ga4_social_btn_data()

        if (window.UGrequest.page_type === "index") {
            ga4_index_shop_by_category_data()
            ga4_index_ugreen_fits_your_life_data()
            ga4_index_ugreen_benefits_data()
            ga4_index_ugreen_blogs_data()

        }
        if (window.UGrequest.page_type === "collection") {
            ga4_collection_top_icons_bar_data()
            ga4_collection_faq_data()
        }

        if (window.UGrequest.page_type === "product") {
            setTimeout(() => {
                console.log("产品页面逻辑已经执行====================")
                ga4_product_info_area_data()
                ga4_product_tabs_data()
                ga4_product_a_plus_data()
                ga4_product_faq_data()
                ga4_product_add_to_cart_data()
            }, 1000)
        }
    })


}